import { useCallback, useContext, useMemo, useEffect } from "react";

import { LS_USER } from "constants/key";
import * as ls from "../localStorage";
import { AuthContext } from "./AuthProvider";
import { message } from "antd";
import util from "helpers/util";
import apiUser from "constants/api/apiUser";
import apiAuth from "constants/api/apiAuth";

export default function useAuth() {
  const { userData, setUserData } = useContext(
    AuthContext
  );

  const checkVersion = () => {
    apiAuth.checkVersion().then((res) => {
      if (res?.success) {
        let version = ls.load("api-version");
        console.log(version);
        if (!version || res?.result !== version) {
          ls.clear();
          ls.set("api-version", res?.result);
          window.location.reload();
        }
      }
    })
  };

  const token = useMemo(() => {
    return userData?.token;
  }, [userData]);

  const isAuthenticated = !util.isNullOrEmpty(userData?.token);

  const handleLogin = useCallback((result) => {
    setUserData(result);

    ls.set(LS_USER, result);

    if(result.userInfo.requirePasswordChange)
      document.location.href = "/changepassword";
    else
      document.location.href = "/home";
  }, []);

  const handleLogout = useCallback(async () => {
    apiUser.logout()
      .then((res) => {
        if(res?.success){
          ls.remove(LS_USER);
          ls.set("logout", Date.now().toString());
    
          document.location.href = "/";
        }
        else{
          //Code will reach here if Logout from keycloak failed
          message.error(res?.message);
        }
      })
      .catch((err) => {
        util.displayApiError(err);

        ls.remove(LS_USER);
        ls.set("logout", Date.now().toString());
        document.location.href = "/";
       });
  }, []);

  return {
    data: {
      isAuthenticated,
      userData,
      token,
    },
    methods: {
      handleLogin,
      handleLogout,
      checkVersion
    },
  };
}
